<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <router-link to="/agentAddNew"
            ><base-button type="primary" size="sm"
              >เพิ่มตัวแทนใหม่</base-button
            ></router-link
          >
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="agents"
      >
        <template slot="columns">
          <th>รหัสตัวแทน</th>
          <th>ชื่อตัวแทน</th>
          <th>เข้าสู่ระบบล่าสุด</th>
          <th>IP Address ล่าสุด</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <td class="id">
            {{ row.code }}
          </td>
          <td class="name">
            {{ row.name }}
          </td>
          <td class="lastlogin">
            {{ row.lastlogin != null ? row.lastlogin : "-" }}
          </td>
          <td class="lastip">
            {{ row.last_ip != null ? row.last_ip : "-" }}
          </td>
          <td class="text-right" @click="goTo(row.id)">
            <button class="btn btn-warning btn-sm">แก้ไข</button>
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <base-pagination :total="calculateTotal"></base-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "agent-table",
  props: {
    type: {
      type: String,
    },
    title: String,
    agents: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  computed: {
    calculateTotal() {
      return this.agents.length;
    },
  },
  methods: {
    goTo(key) {
      let routeData = this.$router.resolve({ path: "/agent/" + key });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style scoped>
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
</style>
